import React, { FC } from 'react'
import ControlCentreMain from '../../components/ControlCentre/ControlCentreMain'

const ControlCentre: FC = () => <ControlCentreMain />

export default ControlCentre